import { Modal, Typography, Space, Tag } from 'antd';

const { Text, Title } = Typography;

interface KeyboardShortcutsHelpProps {
  open: boolean;
  onClose: () => void;
}

interface ShortcutGroup {
  title: string;
  shortcuts: { keys: string[]; description: string }[];
}

const shortcutGroups: ShortcutGroup[] = [
  {
    title: 'Navigasyon',
    shortcuts: [
      { keys: ['g', 'd'], description: 'Dashboard' },
      { keys: ['g', 'f'], description: 'Firmalar' },
      { keys: ['g', 'b'], description: 'Bayiler' },
      { keys: ['g', 'u'], description: 'Kullanıcılar' },
      { keys: ['g', 'v'], description: 'Agent Versiyonları' },
      { keys: ['g', 'l'], description: 'Loglar' },
      { keys: ['g', 'n'], description: 'Duyurular' },
    ],
  },
  {
    title: 'Genel',
    shortcuts: [
      { keys: ['?'], description: 'Bu yardım penceresini aç' },
      { keys: ['Esc'], description: 'Kapat / İptal' },
    ],
  },
];

function KeyCombo({ keys }: { keys: string[] }) {
  return (
    <Space size={4}>
      {keys.map((key, index) => (
        <span key={index}>
          <Tag
            style={{
              fontFamily: 'monospace',
              fontWeight: 600,
              padding: '2px 8px',
              borderRadius: 4,
              background: '#f5f5f5',
              border: '1px solid #d9d9d9',
            }}
          >
            {key.toUpperCase()}
          </Tag>
          {index < keys.length - 1 && (
            <Text type="secondary" style={{ margin: '0 4px' }}>+</Text>
          )}
        </span>
      ))}
    </Space>
  );
}

export function KeyboardShortcutsHelp({ open, onClose }: KeyboardShortcutsHelpProps) {
  return (
    <Modal
      title="Klavye Kısayolları"
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      {shortcutGroups.map((group, groupIndex) => (
        <div key={groupIndex} style={{ marginBottom: groupIndex < shortcutGroups.length - 1 ? 24 : 0 }}>
          <Title level={5} style={{ marginBottom: 12 }}>{group.title}</Title>
          <div style={{ display: 'grid', gap: 8 }}>
            {group.shortcuts.map((shortcut, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  background: '#fafafa',
                  borderRadius: 4,
                }}
              >
                <Text>{shortcut.description}</Text>
                <KeyCombo keys={shortcut.keys} />
              </div>
            ))}
          </div>
        </div>
      ))}

      <div style={{ marginTop: 24, padding: 12, background: '#e6f4ff', borderRadius: 4 }}>
        <Text type="secondary">
          <strong>İpucu:</strong> İki tuşlu kısayollar için önce ilk tuşa basın, sonra ikinci tuşa basın.
          Örneğin: <KeyCombo keys={['g', 'f']} /> için önce <Tag>G</Tag> sonra <Tag>F</Tag>
        </Text>
      </div>
    </Modal>
  );
}
